module.exports = __webpack_public_path__ + "img/changi.da9757f4.jpg";